import React, { useEffect, useState } from 'react';

const SB_URL = "https://bhdvltxqdhouvycyxwft.supabase.co";
const SB_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJoZHZsdHhxZGhvdXZ5Y3l4d2Z0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA1NDM2ODYsImV4cCI6MjA3NjExOTY4Nn0.mIVyn9Thbz7G3FMgnys5jC9iJFa0kBMAlWu9oi1vuYs";

interface Post {
  id: string;
  title: string;
  excerpt: string;
  thumbnail_url: string | null;
  social_url: string;
  published_at: string;
}

export function NewsPage() {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${SB_URL}/rest/v1/NewsPost?order=published_at.desc&limit=20`, {
      headers: { apikey: SB_KEY, Authorization: `Bearer ${SB_KEY}` }
    })
      .then(r => r.json())
      .then(data => { setPosts(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="page-content">
      <section className="hero is-medium about-hero">
        <div className="hero-body">
          <div className="container has-text-centered">
            <p className="about-hero-label">LATEST UPDATES</p>
            <h1 className="title is-2 has-text-white" style={{ fontWeight: 700, letterSpacing: "2px" }}>
              News & <span style={{ color: "#6ee7b7" }}>Insights</span>
            </h1>
            <p className="subtitle has-text-grey-light mt-3">
              The latest from Sitech eSports
            </p>
          </div>
        </div>
      </section>

      <section className="section about-section">
        <div className="container">
          {loading ? (
            <div className="has-text-centered">
              <p className="has-text-grey-light">Loading posts...</p>
            </div>
          ) : posts.length === 0 ? (
            <div className="has-text-centered">
              <p className="has-text-grey-light is-size-5">No posts yet. Check back soon!</p>
            </div>
          ) : (
            <div className="columns is-multiline">
              {posts.map(post => (
                <div key={post.id} className="column is-4">
                  <a href={post.social_url} target="_blank" rel="noopener noreferrer" className="news-card-link">
                    <div className="news-card">
                      <div className="news-card-thumbnail">
                        {post.thumbnail_url ? (
                          <img src={post.thumbnail_url} alt={post.title} />
                        ) : (
                          <div className="news-card-placeholder">
                            <i className="fa-solid fa-newspaper fa-2x"></i>
                          </div>
                        )}
                      </div>
                      <div className="news-card-content">
                        <p className="news-card-date">{new Date(post.published_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
                        <h3 className="news-card-title">{post.title}</h3>
                        <p className="news-card-excerpt">{post.excerpt}</p>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
